import React from 'react';
import { useTranslation } from 'react-i18next';
import { BringzzText } from "@bringzz/components";
import PostingCardElement from 'components/BringzzPostingCardElement';
import { ShimmerCard, ShimmerAvatar, ShimmerText, ShimmerImage } from './Shimmer';

const LoadingPost = () => (
  <div className="p-4 space-y-4">
    <ShimmerCard className="mb-4">
      <div className="flex items-center mb-4">
        <ShimmerAvatar size="h-12 w-12" />
        <div className="ml-4 flex-1">
          <ShimmerText width="w-1/3" className="mb-2" />
          <ShimmerText width="w-1/4" />
        </div>
      </div>
      <ShimmerImage className="w-full h-48 mb-4" />
      <ShimmerText className="mb-2" />
      <ShimmerText width="w-3/4" />
    </ShimmerCard>
  </div>
);

const PostsTab = ({ loading, error, posts, pharmacy, user, collections = [] }) => {
  const { t } = useTranslation('pharmacyProfile');
  
  if (loading) {
    return (
      <div className="p-4">
        {[1, 2].map((item) => (
          <LoadingPost key={item} />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 text-center text-red-500">
        <BringzzText tag="p">{t('tabs.posts.failed_to_load')}</BringzzText>
      </div>
    );
  }

  if (!posts || posts.length === 0) {
    return (
      <div className="p-4 text-center">
        <BringzzText className="text-gray-500">{t('tabs.posts.no_posts')}</BringzzText>
      </div>
    );
  }

  return (
    <div>
      {posts.map(post => (
        <PostingCardElement
          key={post.id}
          post={{
            ...post,
            user_pic: post.user_pic || pharmacy?.pharmacyPic || null,
            user_first_name: post.user_first_name || pharmacy?.name || '',
            user_last_name: post.user_last_name || '',
            isBookmarked: post.isBookmarked || false
          }}
          user={{
            ...user,
            fullName: pharmacy?.name || user?.fullName
          }}
          preview={false}
          collections={collections}
          pharmacyName={pharmacy?.name}
        />
      ))}
    </div>
  );
};

export default PostsTab; 